/* eslint-disable import/prefer-default-export */
/* eslint-disable func-names */
import axios from "axios";
import Cookies from "js-cookie";
import { getParamsUrlString } from "../helpers";

export function* callApiServiceCommon(payload) {
  const urlParam = yield Cookies.get("autoketing_thank_email_session");
  const shopDomain = yield getParamsUrlString(urlParam, "shop");

  const url = payload.url;
  const method = payload.method;
  const params = payload.params;
  params.shop_domain = yield shopDomain;

  if (typeof params !== "object") {
    return yield;
  }
  // POST
  if (method === "POST") {
    const Array = Object.keys(params);
    const bodyFormData = new FormData();
    yield Array.forEach((element) => {
      bodyFormData.append(element, params[element]);
    });
    bodyFormData.append("url", urlParam);
    return yield axios({
      method,
      url,
      data: bodyFormData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: Cookies.get("autoketing_thank_email_session"),
      },
    })
      .then((response) => {
        return response.status === 200 ? response.data : "";
      })
      .catch((error) => {
        console.log(error);
      });
  }
  // GET
  return yield axios({
    method: "get",
    url,
    params,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: Cookies.get("autoketing_thank_email_session"),
    },
  })
    .then(function (response) {
      return response.status === 200 ? response.data : [];
    })
    .catch(function () {
      return [];
    });
}
